module.exports = "<section id=\"form\"><!--form-->\r\n  <div class=\"container\">\r\n    <login></login>\r\n  </div>\r\n</section><!--/form-->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/adminUser/logUser/logUser.component.html
// module id = 576
// module chunks = 1